import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Callback = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const fetchToken = async () => {
            const instanceUrl = localStorage.getItem('instanceUrl');
            const sessionId = localStorage.getItem('miauth_session');

            if (!instanceUrl || !sessionId) {
                navigate('/login');
                return;
            }

            try {
                // MiAuth チェックエンドポイント
                const response = await fetch(`${instanceUrl}/api/miauth/${sessionId}/check`, {
                    method: 'POST'
                });
                
                if (!response.ok) {
                    navigate('/error');
                    return;
                }

                const data = await response.json();

                if (data.token) {
                    // 権限チェック: api/i を呼び出し、isAdminを確認
                    const userRes = await fetch(`${instanceUrl}/api/i`, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ i: data.token })
                    });
                    const user = await userRes.json();

                    if (user && user.isAdmin) {
                        localStorage.setItem('authToken', data.token);
                        localStorage.removeItem('miauth_session');
                        navigate('/files', { replace: true });
                    } else {
                        alert("Access denied: Administrator privileges required.");
                        navigate('/login');
                    }
                } else {
                    navigate('/error');
                }
            } catch (error) {
                console.error('Error during MiAuth check:', error);
                navigate('/error');
            }
        };

        fetchToken();
    }, [navigate]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
        </div>
    );
};

export default Callback;
